import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { EditTabs } from 'components/EditTabs';
import { PATH_DASHBOARD } from 'routes/paths';
import { BannerList } from '../banner/BannerList';
import { StoryList } from '../story/StoryList';
import { useTabs } from 'hooks/useTabs';

export enum MAIN_TAB_VALUES {
  BANNERS = 'banners',
  STORIES = 'stories',
}

const TABS = [
  { value: MAIN_TAB_VALUES.BANNERS, label: 'Баннеры' },
  { value: MAIN_TAB_VALUES.STORIES, label: 'Истории' },
];

interface MainListProps {
  tab: MAIN_TAB_VALUES;
}

const MainList = ({ tab }: MainListProps) => {
  const navigate = useNavigate();

  const { currentTab, onChangeTab, setCurrentTab } = useTabs(TABS[0].value);

  useEffect(() => {
    setCurrentTab(tab);
  }, [setCurrentTab, tab]);

  const handleChangeTab = useCallback(
    (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
      switch (newValue) {
        case MAIN_TAB_VALUES.BANNERS:
          navigate(PATH_DASHBOARD.banner.root);
          break;

        case MAIN_TAB_VALUES.STORIES:
          navigate(PATH_DASHBOARD.story.root);
          break;

        default:
          break;
      }

      onChangeTab(event, newValue);
    },
    [navigate, onChangeTab]
  );

  return (
    <>
      <EditTabs tabs={TABS} currentTab={currentTab} onChangeTab={handleChangeTab} />

      {currentTab === MAIN_TAB_VALUES.BANNERS && <BannerList />}

      {currentTab === MAIN_TAB_VALUES.STORIES && <StoryList />}
    </>
  );
};

export default MainList;
